import { apiClient } from './client';
import type { ApiResponse } from './types';
import type { AdminRole } from '../store/auth';

export interface AdminRow {
  id: number;
  username: string;
  displayName: string | null;
  role: AdminRole;
  enabled: boolean;
  createdAt: string;
}

export interface ListAdminsResult {
  total: number;
  rows: AdminRow[];
}

export interface CreateAdminBody {
  username: string;
  password: string;
  displayName?: string | null;
  role: AdminRole;
}

export interface PatchAdminBody {
  displayName?: string | null;
  role?: AdminRole;
}

export async function listAdmins(params: { keyword?: string; limit?: number; offset?: number } = {}): Promise<ListAdminsResult> {
  const r = await apiClient.get<ApiResponse<ListAdminsResult>>('/admins', { params });
  return r.data.data!;
}

export async function createAdmin(body: CreateAdminBody): Promise<{ id: number }> {
  const r = await apiClient.post<ApiResponse<{ id: number }>>('/admins', body);
  return r.data.data!;
}

export async function patchAdmin(id: number, body: PatchAdminBody): Promise<void> {
  await apiClient.patch(`/admins/${id}`, body);
}

export async function enableAdmin(id: number): Promise<void> {
  await apiClient.post(`/admins/${id}/enable`);
}

export async function disableAdmin(id: number): Promise<void> {
  await apiClient.post(`/admins/${id}/disable`);
}

export async function resetAdminPassword(id: number, newPassword: string): Promise<void> {
  await apiClient.post(`/admins/${id}/reset-password`, { newPassword });
}

export async function changeMyPassword(oldPassword: string, newPassword: string): Promise<void> {
  await apiClient.post('/auth/change-password', { oldPassword, newPassword });
}
